module.exports = __webpack_public_path__ + "static/media/self-research.d6b5f51a.mp4";